/* ============================================================
   KABLA · Recomendador inteligente de pruebas
   Shopify Online Store 2.0 — JavaScript vanilla
   ============================================================ */
(function () {
  'use strict';

  var MXN = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 });
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); };
  
  // Limpieza de strings y remoción de "Default Title"
  var clean = function (t) {
    return String(t)
      .replace(/\s*\([A-Z0-9/·\-\s]+\)/g, '')
      .replace(/\s*Default Title\s*/gi, '')
      .trim();
  };

  /* SVG inline */
  var P = {
    search: '<circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>',
    help: '<circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/>',
    bag: '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/>',
    arrow: '<path d="M5 12h14M13 6l6 6-6 6"/>',
    clock: '<circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/>',
    spark: '<path d="M12 3l1.9 5.8L20 11l-6.1 2.2L12 19l-1.9-5.8L4 11l6.1-2.2L12 3z"/>',
    cart: '<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>',
    building: '<path d="M6 22V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v18"/><path d="M2 22h20"/><path d="M9 8h1M14 8h1M9 12h1"/>',
    cross: '<path d="M12 2v20M2 12h20"/>',
    school: '<path d="M22 10 12 5 2 10l10 5 10-5Z"/><path d="M6 12v5c0 1 2.7 2 6 2s6-1 6-2v-5"/>',
    user: '<circle cx="12" cy="8" r="3.4"/><path d="M5 20c0-4 3.2-6.5 7-6.5S19 16 19 20"/>',
    sector: '<circle cx="12" cy="12" r="9"/><path d="M12 8v.01M12 11v5"/>',
    Panel: '<rect x="8" y="3" width="8" height="18" rx="2"/><path d="M8 8h8M8 11h8"/><path d="M10 17h4"/>',
    Frasco: '<path d="M6 8h12l-1.2 12.1A2 2 0 0 1 14.8 22H9.2a2 2 0 0 1-2-1.9L6 8Z"/><rect x="5" y="3" width="14" height="5" rx="1.6"/>',
    Saliva: '<path d="M14 3c-3.4-.5-7 2-7.8 5.5-.5 2.1.2 3.3-.7 4.8-.6.9.3 1.6 1.1 1.8.2 2 .8 3.4 2.3 4.6"/><path d="M9 18c1.9 1.1 4.2 1.2 6 .6"/><path d="m14.6 13.4 5.4-2.3"/>',
    Tira: '<rect x="7" y="3" width="6" height="18" rx="2"/><rect x="8.6" y="6" width="3" height="5" rx="1.5"/><rect x="15" y="5" width="4" height="14" rx="1.6"/><path d="M16 9h2M16 12h2M16 15h2"/>',
    Cassette: '<rect x="5" y="6" width="14" height="12" rx="2"/><path d="M9 6v12"/><path d="M12 10h5M12 13h5"/>'
  };

  function svg(name, size, color, w) {
    return svgRaw(P[name] || '', size, color, w);
  }

  function svgRaw(inner, size, color, w) {
    return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="' + (color || 'currentColor') +
      '" stroke-width="' + (w || 2) + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + inner + '</svg>';
  }

  function Reco(root) {
    var D = window.KABLA_RECO_DATA;
    if (!D) { return; }
    this.root = root;
    this.D = D;
    this.brandLogos = {};
    (D.BRANDS || []).forEach(function (b) {
      var url = root.getAttribute('data-logo-' + b.key.toLowerCase());
      this.brandLogos[b.key] = url || '';
    }, this);
    this.copy = {};
    var copyEl = root.querySelector('[data-kr-copy]');
    if (copyEl) { try { this.copy = JSON.parse(copyEl.textContent) || {}; } catch (e) { this.copy = {}; } }
    this.state = {
      step: 0, uso: '', sector: '', volumen: '', urgencia: '',
      params: [], formats: [], brands: [],
      sel: {}, limit: 8, openBrand: undefined
    };
    this.els = {
      progress: root.querySelector('[data-kr-progress]'),
      body: root.querySelector('[data-kr-body]'),
      aside: root.querySelector('[data-kr-aside]')
    };
    this.bind();
    this.render();
  }

  Reco.prototype.t = function (k, fb) {
    var v = this.copy[k];
    return v === undefined || v === null || v === '' ? fb : v;
  };

  Reco.prototype.set = function (patch) { Object.assign(this.state, patch); this.render(); };

  Reco.prototype.toggle = function (key, val) {
    var arr = this.state[key].slice(), i = arr.indexOf(val);
    if (i > -1) { arr.splice(i, 1); } else { arr.push(val); }
    var p = { limit: 8 }; p[key] = arr; this.set(p);
  };

  Reco.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (ev) {
      var el = ev.target.closest('[data-act]');
      if (!el || !self.root.contains(el)) { return; }
      var act = el.getAttribute('data-act'), v = el.getAttribute('data-v'), s = self.state;
      switch (act) {
        case 'step': self.set({ step: parseInt(v, 10), limit: 8 }); break;
        case 'next': self.set({ step: s.step + 1, limit: 8 }); break;
        case 'back': self.set({ step: Math.max(0, s.step - 1), limit: 8 }); break;
        case 'uso': self.set({ uso: v, step: 2 }); break;
        case 'sector': self.set({ sector: v, step: 3 }); break;
        case 'volumen': self.set({ volumen: v, step: 4 }); break;
        case 'urgencia': self.set({ urgencia: v, step: 5 }); break;
        case 'param': self.toggle('params', v); break;
        case 'format': self.toggle('formats', v); break;
        case 'brand': self.toggle('brands', v); break;
        case 'group': self.set({ openBrand: self.state.openBrand === v ? '' : v, limit: 8 }); break;
        case 'more': self.set({ limit: s.limit + 12 }); break;
        case 'reset': self.set({ step: 0, uso: '', sector: '', volumen: '', urgencia: '', params: [], formats: [], brands: [], limit: 8 }); break;
        case 'sel': self.bumpSel(v, parseInt(el.getAttribute('data-d'), 10)); break;
        case 'add': 
          var pObj = self.product(v);
          var qty = parseInt(el.getAttribute('data-q'), 10) || 1;
          if (pObj && !pObj.avail) {
            self.redirectToWhatsApp(pObj, qty);
          } else {
            self.addToCart(v, qty, el); 
          }
          break;
      }
    });
  };

  Reco.prototype.bumpSel = function (vid, d) {
    var cur = this.selFor(vid), sel = Object.assign({}, this.state.sel);
    sel[vid] = Math.max(1, cur + d);
    this.set({ sel: sel });
  };

  Reco.prototype.suggestFor = function (p) {
    var vol = null, s = this.state;
    this.D.VOLUMEN_OPTIONS.forEach(function (o) { if (o.key === s.volumen) { vol = o; } });
    return vol && p.kit ? Math.max(1, Math.ceil(vol.tests / p.kit)) : 1;
  };

  Reco.prototype.product = function (vid) {
    var out = null;
    this.D.PRODUCTS.forEach(function (p) { if (String(p.vid) === String(vid)) { out = p; } });
    return out;
  };

  Reco.prototype.selFor = function (vid) {
    var p = this.product(vid);
    return this.state.sel[vid] === undefined ? this.suggestFor(p) : this.state.sel[vid];
  };

  /* ============================================================
     REDIRECCIÓN A WHATSAPP (PRODUCTOS BAJO PEDIDO)
     ============================================================ */
  Reco.prototype.redirectToWhatsApp = function (p, qty) {
    var phone = "5218144441001";
    var rawTitle = p.title || '';
    
    // 1. Obtiene el SKU de las propiedades del objeto o lo busca en el título original
    var sku = p.sku || p.variant_sku || p.code;
    if (!sku) {
      var match = rawTitle.match(/SKU:\s*([A-Za-z0-9\-]+)/i) || rawTitle.match(/\(([A-Za-z0-9\-]+)\)$/);
      if (match) { sku = match[1]; }
    }

    // 2. Limpia el título comercial
    var displayTitle = clean(rawTitle);
    
    // 3. Construye el mensaje
    var mensaje = "Hola, quiero comprar este producto de kabla.store bajo pedido: " + displayTitle;
    if (sku) {
      mensaje += " (SKU: " + sku + ")";
    }
    if (qty > 1) {
      mensaje += " - Cantidad: " + qty;
    }

    var url = "https://api.whatsapp.com/send/?phone=" + phone + "&text=" + encodeURIComponent(mensaje) + "&type=phone_number&app_absent=0";
    window.open(url, '_blank');
  };

  /* ============================================================
     CARRITO PURSUIT
     ============================================================ */
  Reco.prototype.addToCart = function (vid, qty, btn) {
    var p = this.product(vid);
    if (!p) {
      console.error('[KABLA] Producto no encontrado:', vid);
      return;
    }
    qty = parseInt(qty, 10) || 1;
    var originalHTML = btn ? btn.innerHTML : '';
    if (btn) {
      btn.disabled = true;
      btn.innerHTML = '<span class="kr-spinner"></span>';
    }
    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(rootPath + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: Number(vid), quantity: Number(qty) })
    })
    .then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          throw new Error(data.description || data.message || 'No se pudo agregar el producto');
        }
        return data;
      });
    })
    .then(function () {
      return fetch(rootPath + 'cart.js?timestamp=' + Date.now(), {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
    })
    .then(function (response) {
      if (!response.ok) throw new Error('No se pudo obtener el carrito');
      return response.json();
    })
    .then(function (cart) {
      var countSelectors = ['.header_cart_count', '[data-cart-count]', '.cart-count', '.site-header__cart-count', '.cart-link__count', '.cart-qty'];
      countSelectors.forEach(function (selector) {
        document.querySelectorAll(selector).forEach(function (el) { el.textContent = cart.item_count; });
      });

      document.querySelectorAll('.cart_total_price').forEach(function (el) {
        if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
          el.innerHTML = theme.Currency.formatMoney(cart.total_price, theme.moneyFormat);
        } else {
          el.innerHTML = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(cart.total_price / 100);
        }
      });

      var cartUrl = window.routes && window.routes.cartUrl ? window.routes.cartUrl : rootPath + 'cart';
      return fetch(cartUrl + '?view=drawer&timestamp=' + Date.now(), {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
    })
    .then(function (response) {
      if (!response.ok) throw new Error('No se pudo obtener el HTML del drawer');
      return response.text();
    })
    .then(function (html) {
      var parser = new DOMParser();
      var newDocument = parser.parseFromString(html, 'text/html');
      var drawer = document.querySelector('#sidebar-cart');
      if (!drawer) return;

      var currentCart = drawer.querySelector('.Cart');
      var newCart = newDocument.querySelector('.Cart');

      if (currentCart && newCart) {
        currentCart.replaceWith(newCart.cloneNode(true));
      } else {
        var cartTemplate = newDocument.querySelector('[data-section-type="cart-template"]');
        if (cartTemplate) {
          var templateCart = cartTemplate.querySelector('.Cart');
          if (templateCart && currentCart) {
            currentCart.replaceWith(templateCart.cloneNode(true));
          }
        }
      }
    })
    .then(function () {
      if (btn) {
        btn.innerHTML = '✓ Agregado';
        btn.style.backgroundColor = 'var(--kr-accent-deep)';
        setTimeout(function () {
          btn.disabled = false;
          btn.innerHTML = originalHTML;
          btn.style.backgroundColor = '';
        }, 1500);
      }
    })
    .catch(function (error) {
      console.error('[KABLA] ERROR CARRITO:', error);
      if (btn) {
        btn.innerHTML = 'Error';
        setTimeout(function () {
          btn.disabled = false;
          btn.innerHTML = originalHTML;
        }, 1800);
      }
    });
  };

  /* ============================================================
     KABLA · MOTOR RECOMENDADOR INTELIGENTE (BÚSQUEDA EXHAUSTIVA)
     ============================================================ */
  Reco.prototype.compute = function () {
    var D = this.D, s = this.state;

    // Conteo de drogas seleccionadas que contiene un producto
    var covered = function (p) {
      if (!s.params.length) return 0;
      return s.params.filter(function (c) { return p.params.indexOf(c) > -1; }).length;
    };

    var fullCov = function (p) { return !s.params.length || covered(p) === s.params.length; };
    var anyCov = function (p) { return !s.params.length || covered(p) > 0; };
    var okFmt = function (p, f) { return !f.length || f.indexOf(p.format) > -1; };
    var okBrand = function (p, b) { return !b.length || b.indexOf(p.brand) > -1; };

    var lbl = function (arr, k, key) {
      var o = arr.filter(function (x) { return x.key === k; })[0];
      return o ? (key ? o[key] : o.label) : k;
    };

    var fmtNames = s.formats.map(function (k) { return lbl(D.FORMATS, k); }).join(' / ');
    var brandNames = s.brands.map(function (k) { return lbl(D.BRANDS, k).split(' · ')[0]; }).join(' / ');
    var drogaNames = s.params.map(function (c) { return D.PARAM_INFO[c].n; }).join(', ');

    // 1. Intento Nivel 1: Coincidencia Estricta (100% Drogas + Formato + Marca)
    var main = D.PRODUCTS.filter(function (p) {
      return fullCov(p) && okFmt(p, s.formats) && okBrand(p, s.brands);
    });

    var usedF = s.formats, usedB = s.brands, note = '';

    // 2. RAMIFICACIÓN EXHAUSTIVA SI EL NIVEL 1 DA 0 RESULTADOS:
    if (!main.length && s.params.length) {
      // Paso B1: Busca en TODO el catálogo qué productos sí tienen el 100% de las drogas (aquí entra Fastline)
      var globalFull = D.PRODUCTS.filter(function (p) { return fullCov(p); });

      if (globalFull.length) {
        main = globalFull;
        usedF = [];
        usedB = []; // Relajamos la marca para que la pestaña de Fastline pueda renderizarse
        note = 'Ninguna combinación de ' + (fmtNames || 'formato') + ' y ' + (brandNames || 'marca') + ' elegida cubre ' + drogaNames + '. Te mostramos todo lo que sí cubre esos parámetros.';
      } else {
        // Paso B2: Si ningún producto tiene el 100%, busca en la marca/formato elegidos los de mayor cobertura
        main = D.PRODUCTS.filter(function (p) {
          return anyCov(p) && okFmt(p, s.formats) && okBrand(p, s.brands);
        });
        note = 'No existe un solo kit que integre todas las drogas elegidas en ' + (brandNames || 'la marca seleccionada') + '. Te mostramos las opciones disponibles con la mayor coincidencia de parámetros.';
      }
    } else if (!main.length && (s.formats.length || s.brands.length)) {
      main = D.PRODUCTS.filter(function (p) { return okBrand(p, s.brands) || okFmt(p, s.formats); });
      note = 'Te mostramos las opciones disponibles para ' + (brandNames || fmtNames) + '.';
    }

    // 3. COINCIDENCIAS PARCIALES SECUNDARIAS (Paneles de 2 de 3 drogas, etc.)
    var partial = D.PRODUCTS.filter(function (p) {
      return !fullCov(p) && covered(p) > 0 && main.indexOf(p) === -1;
    });

    // Ordenamiento por Relevancia (Mayor cobertura de drogas primero)
    var sortFn = function (a, b) {
      return (covered(b) - covered(a)) || (a.price - b.price);
    };

    return {
      covered: covered,
      fullCov: fullCov,
      okFmt: okFmt,
      okBrand: okBrand,
      full: main.slice().sort(sortFn),
      partial: partial.slice().sort(sortFn),
      alt: [],
      note: note
    };
  };

  /* ============================================================
     RENDERIZADO DE RESULTADOS
     ============================================================ */
  Reco.prototype.viewResults = function (c) {
    var self = this, D = this.D, s = this.state;
    var chipsCount = s.params.length + s.formats.length + s.brands.length;

    var out = '<div class="kr-res__head"><div><p class="kr-res__kicker">' + esc(this.t('res_kicker', 'Recomendaciones')) + '</p>' +
      '<h3 class="kr-res__title">' + esc(chipsCount ? this.t('res_title', 'Recomendaciones para ti') : this.t('res_title_all', 'Catálogo completo de pruebas')) + '</h3>' +
      '<p class="kr-res__sub">' + c.full.length + (c.full.length === 1 ? ' producto coincide con todas las drogas seleccionadas.' : ' productos coinciden con todas las drogas seleccionadas.') +
      '</p></div>' +
      '<button type="button" class="kr-reset" data-act="reset">↻ ' + esc(this.t('btn_reset', 'Empezar de nuevo')) + '</button></div>';

    if (c.note) {
      out += '<div class="kr-note"><span class="kr-note__icon">' + svg('spark', 16, '#fff', 2.2) + '</span>' +
        '<div><div class="kr-note__k">' + esc(this.t('note_kicker', 'Ajustamos tu búsqueda')) + '</div><div class="kr-note__t">' + esc(c.note) + '</div></div></div>';
    }

    // Grupos por Marca de los resultados principales
    var groups = D.BRANDS.map(function (b) {
      return { b: b, items: c.full.filter(function (p) { return p.brand === b.key; }) };
    }).filter(function (g) { return g.items.length; });

    var openKey = s.openBrand === undefined ? (groups[0] ? groups[0].b.key : '') : s.openBrand;

    out += '<div class="kr-brands">' + groups.map(function (g) {
      var open = g.b.key === openKey, items = g.items.slice(0, s.limit), logo = self.brandLogos[g.b.key];
      return '<div class="kr-bgroup' + (open ? ' kr-bgroup--open' : '') + '">' +
        '<button type="button" class="kr-bgroup__btn" data-act="group" data-v="' + esc(g.b.key) + '" aria-expanded="' + open + '" aria-label="' + esc(g.b.label) + '">' +
        (logo ? '<span class="kr-bgroup__logo" style="background-image:url(' + esc(logo) + ')"></span>' : '<span class="kr-bgroup__count" style="flex:0 0 auto;">' + esc(g.b.label) + '</span>') +
        '<span class="kr-bgroup__count">' + g.items.length + (g.items.length === 1 ? ' producto' : ' productos') + '</span>' +
        '<span class="kr-bgroup__chev">' + (open ? '▾' : '▸') + '</span></button>' +
        (open ? '<div class="kr-bgroup__rows">' + items.map(function (p) { return self.rowHTML(p, c); }).join('') +
          (g.items.length > items.length ? '<button type="button" class="kr-more" data-act="more">Ver ' + (g.items.length - items.length) + ' productos más</button>' : '') +
          '</div>' : '') + '</div>';
    }).join('') + '</div>';

    // Coincidencias parciales (Paneles de 2 de 3 drogas, etc.)
    if (c.partial.length) {
      out += '<div class="kr-sub__head"><h4>Coincidencias parciales</h4><span>Cubren algunas de las drogas seleccionadas</span></div>' +
        '<div class="kr-stack">' + c.partial.slice(0, 8).map(function (p) { return self.rowHTML(p, c, 'alt'); }).join('') + '</div>';
    }

    if (!c.full.length && !c.partial.length) {
      out += '<div class="kr-empty">' + svg('search', 36, '#DDD', 1.6) +
        '<p>' + esc(this.t('empty_text', 'No encontramos productos con esa combinación exacta. Prueba quitando algún filtro o parámetro.')) + '</p></div>';
    }

    return out;
  };

  Reco.prototype.score = function () {
    var s = this.state, D = this.D, f = function (list, key) { var o = list.filter(function (x) { return x.key === key; })[0]; return o ? o.score : 0; };
    return f(D.USO_OPTIONS, s.uso) + f(D.VOLUMEN_OPTIONS, s.volumen) + f(D.URGENCIA_OPTIONS, s.urgencia);
  };

  Reco.prototype.render = function () {
    var s = this.state, c = this.compute();
    if (this.els.progress) { this.els.progress.innerHTML = this.viewProgress(); }
    if (this.els.aside) { this.els.aside.innerHTML = this.viewProfile(); }
    if (this.els.body) { this.els.body.innerHTML = s.step === 8 ? this.viewResults(c) : this.viewStep(s.step); }
  };

  Reco.prototype.viewProgress = function () {
    var s = this.state;
    if (!s.step) { return ''; }
    var pct = Math.min(100, (Math.min(s.step, 8) / 8) * 100);
    var phase = s.step <= 4 ? 'Tu operación' : s.step <= 7 ? 'Filtros de producto' : 'Resultados';
    return '<div class="kr__progress-top"><span class="kr__phase">' + phase + '</span>' +
      (s.step <= 7 ? '<span class="kr__stepnum">Paso ' + s.step + ' de 7</span>' : '') +
      '</div><div class="kr-bar"><i style="width:' + pct + '%"></i></div>';
  };

  Reco.prototype.viewProfile = function () {
    var s = this.state, sc = this.score();
    var label = sc >= 9 ? 'Compra grande' : sc >= 5 ? 'Compra media' : sc > 0 ? 'Compra pequeña' : 'Sin calificar';
    var color = sc >= 9 ? '#D94F00' : sc >= 5 ? '#F27400' : sc > 0 ? '#FF9900' : '#FFC37A';
    var rows = [['Operación', s.uso], ['Sector', s.sector], ['Pruebas/mes', s.volumen], ['Necesita', s.urgencia]];
    var done = rows.filter(function (r) { return !!r[1]; }).length;
    return '<div class="kr-profile">' +
      '<div class="kr-profile__top"><span class="kr-profile__label">' + esc(this.t('profile_label', 'Tu perfil')) + '</span>' +
      '<span class="kr-profile__score" style="background:' + color + '"><i></i>' + label + '</span></div>' +
      '<div class="kr-profile__count"><b>' + done + '</b><span>/ 4 ' + esc(this.t('profile_answers', 'respuestas')) + '</span></div>' +
      '<div class="kr-bar"><i style="width:' + (done / 4) * 100 + '%"></i></div>' +
      '<div class="kr-profile__rows">' + rows.map(function (r, i) {
        var on = !!r[1];
        return '<div class="kr-prow' + (on ? ' kr-prow--on' : '') + '"><span class="kr-prow__n">0' + (i + 1) + '</span>' +
          '<span class="kr-prow__k">' + esc(r[0]) + '</span><span class="kr-prow__v">' + esc(on ? r[1] : 'Pendiente') + '</span></div>';
      }).join('') + '</div>' +
      '<p class="kr-profile__note">' + esc(this.t('profile_note', 'Con esto ajustamos volumen, formato y marca recomendados.')) + '</p></div>';
  };

  Reco.prototype.viewStep = function (step) {
    var D = this.D, s = this.state, self = this;
    var head = function (kicker, title, hint) {
      return '<p class="kr-step__kicker">' + kicker + '</p><h3 class="kr-step__title">' + title + '</h3>' +
        (hint ? '<p class="kr-step__hint">' + hint + '</p>' : '');
    };
    var backFoot = function (extra) {
      return '<div class="kr-step__foot"><button type="button" class="kr-back" data-act="back">← ' + esc(self.t('btn_back', 'Atrás')) + '</button>' + (extra || '') + '</div>';
    };

    if (step === 0) {
      return '<div class="kr-intro">' +
        '<div class="kr-intro__icon">' + svg('search', 30, '#fff', 2.2) + '</div>' +
        '<h3 class="kr-intro__title">' + esc(this.t('intro_title', 'Elige según tus necesidades de detección')) + '</h3>' +
        '<p class="kr-intro__text">' + esc(this.t('intro_text', 'Te hacemos unas preguntas rápidas sobre tu operación y luego filtramos el catálogo por drogas, formato y marca.')) + '</p>' +
        '<div class="kr-intro__cards">' +
        '<button type="button" class="kr-choice kr-choice--primary" data-act="step" data-v="1">' +
        '<span class="kr-choice__icon">' + svg('help', 20, '#fff') + '</span><span><span class="kr-choice__t">' + esc(this.t('cta_guided', 'Ayúdame a elegir')) + '</span>' +
        '<span class="kr-choice__d">' + esc(this.t('cta_guided_sub', 'Perfil de tu empresa + filtros guiados.')) + '</span></span></button>' +
        '<button type="button" class="kr-choice" data-act="step" data-v="8">' +
        '<span class="kr-choice__icon">' + svg('bag', 20, '#fff') + '</span><span><span class="kr-choice__t">' + esc(this.t('cta_direct', 'Ya sé qué quiero')) + '</span>' +
        '<span class="kr-choice__d">' + esc(this.t('cta_direct_sub', 'Ver los ' + D.PRODUCTS.length + ' productos del catálogo.')) + '</span></span></button></div>' +
        '<div class="kr-pills"><span>' + D.PRODUCTS.length + ' productos</span><span>' + D.BRANDS.length + ' marcas</span><span>' + Object.keys(D.PARAM_INFO).length + ' parámetros</span></div></div>';
    }

    if (step === 1) {
      return head(self.t('s1_kicker', 'Pregunta 1'), self.t('s1_title', '¿Para qué tipo de operación es?'), self.t('s1_hint', 'Nos ayuda a priorizar volumen, formato y soporte.')) +
        '<div class="kr-grid kr-grid--2">' + D.USO_OPTIONS.map(function (o) {
          return '<button type="button" class="kr-opt" aria-pressed="' + (s.uso === o.key) + '" data-act="uso" data-v="' + esc(o.key) + '">' +
            '<span class="kr-opt__icon">' + svg(o.icon, 17, '#fff') + '</span><span><span class="kr-opt__t">' + esc(o.label) + '</span>' +
            '<span class="kr-opt__s">' + esc(o.sub) + '</span></span></button>';
        }).join('') + '</div>' +
        '<div class="kr-step__foot"><button type="button" class="kr-back" data-act="step" data-v="0">← ' + esc(self.t('btn_home', 'Volver al inicio')) + '</button></div>';
    }

    if (step === 2) {
      return head(self.t('s2_kicker', 'Pregunta 2'), self.t('s2_title', '¿En qué sector operas?'), self.t('s2_hint', 'Algunos sectores requieren paneles ampliados o fentanilo.')) +
        '<div class="kr-grid kr-grid--sector">' + D.SECTOR_OPTIONS.map(function (o) {
          var k = typeof o === 'string' ? o : o.key;
          var ic = typeof o === 'string' ? P.sector : o.icon;
          return '<button type="button" class="kr-opt kr-opt--sector" aria-pressed="' + (s.sector === k) + '" data-act="sector" data-v="' + esc(k) + '">' +
            '<span class="kr-opt__icon">' + svgRaw(ic, 15, '#888') + '</span><span class="kr-opt__t">' + esc(k) + '</span></button>';
        }).join('') + '</div>' + backFoot();
    }

    if (step === 3) {
      return head(self.t('s3_kicker', 'Pregunta 3'), self.t('s3_title', '¿Cuántas pruebas al mes estimas?'), self.t('s3_hint', 'Los kits vienen de 20 a 50 pruebas. Esto define el volumen recomendado.')) +
        '<div class="kr-grid kr-grid--vol">' + D.VOLUMEN_OPTIONS.map(function (o) {
          return '<button type="button" class="kr-opt kr-opt--vol" aria-pressed="' + (s.volumen === o.key) + '" data-act="volumen" data-v="' + esc(o.key) + '">' +
            '<span class="kr-opt__t">' + esc(o.key) + '</span><span class="kr-opt__s">' + esc(o.sub) + '</span></button>';
        }).join('') + '</div>' + backFoot();
    }

    if (step === 4) {
      return head(self.t('s4_kicker', 'Pregunta 4'), self.t('s4_title', '¿Para cuándo lo necesitas?'), self.t('s4_hint', 'Para sugerirte el volumen y la disponibilidad adecuados.')) +
        '<div class="kr-stack">' + D.URGENCIA_OPTIONS.map(function (o) {
          return '<button type="button" class="kr-opt" aria-pressed="' + (s.urgencia === o.key) + '" data-act="urgencia" data-v="' + esc(o.key) + '">' +
            '<span class="kr-opt__dot" style="background:' + o.dot + '">' + svg('clock', 15, '#fff', 2.2) + '</span>' +
            '<span><span class="kr-opt__t">' + esc(o.key) + '</span><span class="kr-opt__s">' + esc(o.sub) + '</span></span></button>';
        }).join('') + '</div>' + backFoot();
    }

    if (step === 5) {
      return head(self.t('s5_kicker', 'Filtro 1 de 3'), self.t('s5_title', '¿Qué drogas quieres identificar?'), self.t('s5_hint', 'Selecciona todos los parámetros que necesites. Puedes dejarlo vacío.')) +
        D.PARAM_GROUPS.map(function (g) {
          return '<div class="kr-group__label">' + esc(g.label) + '</div><div class="kr-grid kr-grid--params">' +
            g.codes.map(function (code) {
              var info = D.PARAM_INFO[code];
              return '<button type="button" class="kr-param" aria-pressed="' + (s.params.indexOf(code) > -1) + '" data-act="param" data-v="' + code + '">' +
                '<span class="kr-param__code" style="background:' + D.CAT_COLOR[info.c] + '">' + code + '</span>' +
                '<span class="kr-param__n">' + esc(info.n) + '</span><span class="kr-check"></span></button>';
            }).join('') + '</div>';
        }).join('') +
        backFoot('<div style="display:flex;align-items:center;gap:14px;"><span class="kr-count"><b>' + s.params.length + '</b> ' + esc(self.t('label_selected', 'seleccionados')) + '</span>' +
          '<button type="button" class="kr-next" data-act="next">' + esc(self.t('btn_continue', 'Continuar')) + svg('arrow', 15) + '</button></div>');
    }

    if (step === 6) {
      var c6 = this.compute();
      return head(self.t('s6_kicker', 'Filtro 2 de 3'), self.t('s6_title', '¿Qué formato prefieres?'), self.t('s6_hint', 'Puedes elegir más de uno o ninguno.')) +
        '<div class="kr-grid kr-grid--cards">' + D.FORMATS.map(function (f) {
          var n = D.PRODUCTS.filter(function (p) { return p.format === f.key && c6.fullCov(p) && c6.okBrand(p, s.brands); }).length;
          return '<button type="button" class="kr-card' + (n ? '' : ' kr-card--empty') + '" aria-pressed="' + (s.formats.indexOf(f.key) > -1) + '" data-act="format" data-v="' + esc(f.key) + '">' +
            '<span class="kr-card__icon">' + svg(f.key, 20, '#fff', 1.8) + '</span>' +
            '<span class="kr-card__t">' + esc(f.label) + '</span><span class="kr-card__d">' + esc(f.desc) + '</span>' +
            '<span class="kr-card__c">' + (n ? n + ' productos' : 'Sin coincidencia exacta — te sugerimos alternativas') + '</span>' +
            '<span class="kr-card__check"></span></button>';
        }).join('') + '</div>' +
        backFoot('<button type="button" class="kr-next" data-act="next">' + esc(self.t('btn_continue', 'Continuar')) + svg('arrow', 15) + '</button>');
    }

    if (step === 7) {
      var c7 = this.compute();
      return head(self.t('s7_kicker', 'Filtro 3 de 3'), self.t('s7_title', '¿Alguna marca en particular?'), self.t('s7_hint', 'Si no eliges ninguna, te mostramos todas.')) +
        '<div class="kr-grid kr-grid--brands">' + D.BRANDS.map(function (b) {
          var n = D.PRODUCTS.filter(function (p) { return p.brand === b.key && c7.fullCov(p) && c7.okFmt(p, s.formats); }).length;
          var logo = self.brandLogos[b.key];
          return '<button type="button" class="kr-card' + (n ? '' : ' kr-card--empty') + '" aria-pressed="' + (s.brands.indexOf(b.key) > -1) + '" data-act="brand" data-v="' + esc(b.key) + '" aria-label="' + esc(b.label) + '">' +
            (logo ? '<span class="kr-logo" style="background-image:url(' + esc(logo) + ')"></span>' : '<span class="kr-card__t">' + esc(b.label) + '</span>') +
            '<span class="kr-sr">' + esc(b.label) + '</span>' +
            '<span class="kr-card__d">' + esc(b.desc) + '</span>' +
            '<span class="kr-card__c">' + (n ? n + ' productos' : 'Sin coincidencia exacta — te sugerimos alternativas') + '</span>' +
            '<span class="kr-card__check"></span></button>';
        }).join('') + '</div>' +
        backFoot('<button type="button" class="kr-next kr-next--accent" data-act="next">' + esc(self.t('btn_results', 'Ver resultados')) + svg('arrow', 15) + '</button>');
    }
    return '';
  };

  Reco.prototype.rowHTML = function (p, c, variant) {
    var s = this.state, D = this.D;
    var sel = this.selFor(p.vid);
    var fmt = (D.FORMATS.filter(function (f) { return f.key === p.format; })[0] || {}).label || p.format;
    var brand = (D.BRANDS.filter(function (b) { return b.key === p.brand; })[0] || { label: p.brand }).label.split(' · ')[0];
    
    var tags = p.params.map(function (code) {
      var hit = s.params.indexOf(code) > -1;
      return '<span class="kr-ptag' + (hit ? ' kr-ptag--hit' : '') + '">' + code + '</span>';
    }).join('');

    var kitLabel = p.kit ? (sel > 1 ? sel + ' kits · ' + sel * p.kit + ' pruebas' : 'Kit de ' + p.kit + ' pruebas') : 'Kit';

    if (variant === 'alt') {
      return '<div class="kr-row kr-row--alt">' +
        '<div class="kr-row__top">' +
          '<span class="kr-row__img" style="background-image:url(' + esc(p.img) + ')"></span>' +
          '<div class="kr-row__main">' +
            '<div class="kr-row__meta">' +
              '<span class="kr-tag-fmt">' + esc(fmt) + '</span>' +
              '<span class="kr-tag-brand">' + esc(brand) + '</span>' +
              (s.params.length ? '<span class="kr-cover">' + c.covered(p) + ' de ' + s.params.length + ' drogas</span>' : '') +
            '</div>' +
            '<div class="kr-row__t">' + esc(clean(p.title)) + '</div>' +
          '</div>' +
        '</div>' +
        '<div class="kr-row__buy">' +
          '<div><div class="kr-row__price">' + MXN.format(p.price) + ' MXN</div></div>' +
          '<button type="button" class="kr-add kr-add--dark" data-act="add" data-v="' + p.vid + '" data-q="1">' + (p.avail ? 'Agregar' : 'Bajo pedido') + '</button>' +
        '</div>' +
      '</div>';
    }

    return '<div class="kr-row">' +
      '<div class="kr-row__top">' +
        '<span class="kr-row__img" style="background-image:url(' + esc(p.img) + ')"></span>' +
        '<div class="kr-row__main">' +
          '<div class="kr-row__meta">' +
            '<span class="kr-tag-fmt">' + esc(fmt) + '</span>' +
            '<span class="kr-tag-brand">' + esc(brand) + '</span>' +
            (p.avail ? '' : '<span class="kr-tag-badge">Bajo pedido</span>') +
          '</div>' +
          '<div class="kr-row__t">' + esc(clean(p.title)) + '</div>' +
          '<div class="kr-row__params">' + tags + '</div>' +
        '</div>' +
      '</div>' +
      '<div class="kr-row__buy">' +
        '<div>' +
          '<div class="kr-row__price">' + MXN.format(p.price * sel) + ' MXN</div>' +
          '<div class="kr-row__kit">' + esc(kitLabel) + '</div>' +
        '</div>' +
        '<div class="kr-row__actions">' +
          '<span class="kr-qty">' +
            '<button type="button" data-act="sel" data-v="' + p.vid + '" data-d="-1" aria-label="Quitar uno">−</button>' +
            '<span>' + sel + '</span>' +
            '<button type="button" data-act="sel" data-v="' + p.vid + '" data-d="1" aria-label="Agregar uno">+</button>' +
          '</span>' +
          '<button type="button" class="kr-add" data-act="add" data-v="' + p.vid + '" data-q="' + sel + '">' +
            svg('cart', 14) + (p.avail ? 'Agregar' : 'Bajo pedido') +
          '</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-kabla-reco]').forEach(function (el) {
      if (el.__kablaReco) { return; }
      el.__kablaReco = new Reco(el);
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(); }); } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.KablaReco = { init: init };
})();